import CONFIG from "@bd-core/config";
import Store_BuildingBlocks from "@bd-components/store-building-blocks";

const Store_Sequences = {
  data: null,
  init: () => {
    Store_Sequences.data = CONFIG.sequences;
  },
  getNext: (answer) => {
    const sequenceData = Store_Sequences.data?.[answer.current_block] ?? undefined;
    if (!sequenceData) return null;
    
    const defaultNext = sequenceData?.next?.["default"] ?? null;
    const nextSequence = sequenceData?.next?.[answer.answer_data] ?? defaultNext;
    return nextSequence ? nextSequence : defaultNext;
  },
  isLikeResult: (bbId) => {
    const block = Store_BuildingBlocks.get(bbId);
    if (!block) return false;
    return block.type === "result" || block.type === "result_categories_score";
  },
};

export default Store_Sequences;
